/**
 * Documented `stoq:*` CustomEvents (see api_docs/custom-events.mdx).
 * All SDK events are dispatched on `window`; in SSR (no `window`) dispatch is
 * a silent no-op.
 */
export const EVENT_LOADED = 'stoq:loaded'
export const EVENT_MODAL_OPENED = 'stoq:restock-modal:opened'
export const EVENT_SIGNUP_SUBMITTED = 'stoq:restock-modal:submitted'
export const EVENT_MODAL_CLOSED = 'stoq:restock-modal:closed'
export const EVENT_PREORDER_MODAL_OPENED = 'stoq:preorder-modal:opened'
export const EVENT_PREORDER_MODAL_CLOSED = 'stoq:preorder-modal:closed'
export const EVENT_PREORDER_PAYMENT_OPTION_SELECTED = 'stoq:preorder-payment-option:selected'

export function emit(name: string, detail: unknown): void {
  if (typeof window === 'undefined') return
  if (typeof window.dispatchEvent !== 'function') return
  if (typeof CustomEvent === 'undefined') return
  try {
    window.dispatchEvent(new CustomEvent(name, { detail }))
  } catch {
    // Event dispatch must never break the host page.
  }
}
